module.exports = __webpack_public_path__ + "static/media/loading.9391b37b.svg";